import accounting from 'accounting';

const { location } = window;
let SIGN_REGEXP = /([yMdhsm])(\1*)/g;
let DEFAULT_PATTERN = 'yyyy-MM-dd';
const QU_LOCAL_PERMS = 'qu_local_perms';
/* eslint-disable no-undef */
const codeEvn = CODE_EVN;
/* eslint-enable no-undef */
const isDev = codeEvn === 'development';
const DOMAIN = isDev ? 'http://dev.aiclk.com' : 'http://staging.aiclk.com';

function padding(s, len) {
  // eslint-disable-next-line no-param-reassign
  len = len - String(s).length;
  for (let i = 0; i < len; i++) {
    // eslint-disable-next-line no-param-reassign
    s = '0' + s;
  }
  return s;
}

export default {
  getQueryStringByName(name) {
    let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
    let r = window.location.search.substr(1).match(reg);
    let context = '';
    // eslint-disable-next-line eqeqeq
    if (r != null) context = r[2]; // eslint-disable-line no-eq-null
    reg = null;
    r = null;
    return context === null || context === '' || context === 'undefined'
      ? ''
      : context;
  },
  formatDate: {
    format(date, pattern) {
      // eslint-disable-next-line no-param-reassign
      pattern = pattern || DEFAULT_PATTERN;
      return pattern.replace(SIGN_REGEXP, function($0) {
        switch ($0.charAt(0)) {
          case 'y':
            return padding(date.getFullYear(), $0.length);
          case 'M':
            return padding(date.getMonth() + 1, $0.length);
          case 'd':
            return padding(date.getDate(), $0.length);
          case 'w':
            return date.getDay() + 1;
          case 'h':
            return padding(date.getHours(), $0.length);
          case 'm':
            return padding(date.getMinutes(), $0.length);
          case 's':
            return padding(date.getSeconds(), $0.length);
        }
      });
    },
    parse(dateString, pattern) {
      let matchs1 = pattern.match(SIGN_REGEXP);
      let matchs2 = dateString.match(/(\d)+/g);
      if (matchs1.length === matchs2.length) {
        let _date = new Date(1970, 0, 1);
        for (let i = 0; i < matchs1.length; i++) {
          let _int = parseInt(matchs2[i], 10);
          let sign = matchs1[i];
          switch (sign.charAt(0)) {
            case 'y':
              _date.setFullYear(_int);
              break;
            case 'M':
              _date.setMonth(_int - 1);
              break;
            case 'd':
              _date.setDate(_int);
              break;
            case 'h':
              _date.setHours(_int);
              break;
            case 'm':
              _date.setMinutes(_int);
              break;
            case 's':
              _date.setSeconds(_int);
              break;
          }
        }
        return _date;
      }
      return null;
    },
  },
  getUrlSearch() {
    let search;

    let items;

    let item;

    let name;

    let value;

    let args = {};
    search = location.search.length > 0 ? location.search.substring(1) : null;
    items = search ? search.split('&') : '';
    for (let i = 0, len = items.length; i < len; i++) {
      item = items[i].split('=');
      name = decodeURIComponent(item[0]);
      value = (item[1] || '').replace(/(.*)%$/, (match, $1) => {
        return $1 + encodeURIComponent('%');
      });
      value = decodeURIComponent(value || '');
      if (name.length > 0) {
        // 防止为空的参数比如说(?page=2&=invalidParam)
        args[name] = value;
      }
    }
    return args;
  },
  // eslint-disable-next-line func-name-matching
  getPermUrl: function permUrl(menu = [], uris = []) {
    menu.forEach((menuItem) => {
      let { meta = {} } = menuItem;
      if (meta.api) {
        meta.api.forEach((perm) => {
          uris.push(`${perm.project}::${perm.path}`);
        });
      }
      if (menuItem.children) {
        permUrl(menuItem.children, uris);
      }
    });
    return uris;
  },
  savePermApi(perms) {
    localStorage.setItem(QU_LOCAL_PERMS, JSON.stringify(perms));
  },
  checkPermApi(map) {
    let localPerms = [];
    try {
      localPerms = JSON.parse(localStorage.getItem(QU_LOCAL_PERMS)) || [];
    } catch (err) {}

    map.forEach((item) => {
      if (item.children) {
        item.children.forEach((child) => {
          let apiList = child.meta.api || [];
          let isHidden = true;
          for (let i = 0, len = apiList.length; i < len; i++) {
            let api = apiList[i];
            let project = api.project;
            let uri = api.path;
            let key = project + '::' + uri;
            if (localPerms[key] && localPerms[key].has === 1) {
              isHidden = false;
            } else {
              isHidden = true;
              break;
            }
          }
          child.meta.hidden = isHidden;
        });
      }
    });
    return map;
  },

  /**
   *
   * @description 单位 分 转为 元
   * @param {Number} m 金额
   * @param {String} prev 前缀
   * @param {String} symbol 后缀
   * @param {Number} precision 小数位数 默认: 2
   * @retun {String} result
   *
   */
  // eslint-disable-next-line max-params
  fenToYuan(m, prev = '', symbol = '', precision = 2) {
    const _precision = (m || 0) % 100 === 0 ? 0 : precision;
    const o = m ? this.numberCal.div(m, 100) : 0;
    return o === 0
      ? `${prev}0${symbol}`
      : accounting.formatMoney(o, prev, _precision, ',', '.', { symbol });
  },

  /**
   *
   * @description openUrl 打开外部链接;
   * @param {String}  url
   * @param {Boolean} newWin 是否新开窗口/tab; defaults to false;
   * @param {Boolean} record 是否将该链接添加记录到history栈; defaults to false;
   * @return new window;
   *
   */
  openUrl(url, { newWin = false, record = false } = {}) {
    if (newWin) {
      const win = window.open('', '_blank');
      win.location = url;
    } else {
      if (!record) {
        location.href = url;
      } else {
        location.assign(url);
      }
    }
  },

  /**
   *
   * @description 浮点数计算； 规避浮点数的精度丢失；
   * @example eg: 32.80*100 // 3279.9999999999995;
   * @operate abb | sub | mul | div
   * @param {Number} a
   * @param {Number} b
   * @return {Number} result
   *
   */
  numberCal: {
    add(a, b) {
      let c;
      let d;
      try {
        c = a.toString().split('.')[1].length;
      } catch (f) {
        c = 0;
      }
      try {
        d = b.toString().split('.')[1].length;
      } catch (f) {
        d = 0;
      }
      const e = 10 ** Math.max(c, d);
      return (this.mul(a, e) + this.mul(b, e)) / e;
    },
    sub(a, b) {
      let c;
      let d;
      try {
        c = a.toString().split('.')[1].length;
      } catch (f) {
        c = 0;
      }
      try {
        d = b.toString().split('.')[1].length;
      } catch (f) {
        d = 0;
      }
      const e = 10 ** Math.max(c, d);
      return (this.mul(a, e) - this.mul(b, e)) / e;
    },
    mul(a, b) {
      let c = 0;
      const d = a.toString();
      const e = b.toString();
      try {
        c += d.split('.')[1].length;
      } catch (f) {}
      try {
        c += e.split('.')[1].length;
      } catch (f) {}
      return (
        (Number(d.replace('.', '')) * Number(e.replace('.', ''))) / 10 ** c
      );
    },
    div(a, b) {
      let e = 0;
      let f = 0;
      try {
        e = a.toString().split('.')[1].length;
      } catch (f) {}
      try {
        f = b.toString().split('.')[1].length;
      } catch (f) {}
      const c = Number(a.toString().replace('.', ''));
      const d = Number(b.toString().replace('.', ''));
      return this.mul(c / d, 10 ** (f - e));
    },
  },

  /**
   *
   * @description 模拟登陆
   * @param {Number} advUserId
   * @param {String} type  3：开户资质； 2:代理商； 1:广告主
   * @return new window
   *
   */
  simulatedLogin(advUserId = '', type = 1) {
    let url = `${DOMAIN}/index.html`;

    switch (type) {
      case 1:
        url += '?from=admin&to=user';
        url += `&userID=${advUserId}`;
        url += '#/userHome/index';
        break;
      case 2:
        url += '?from=admin&to=agent';
        url += `&userID=${advUserId}`;
        url += '#/accounts/accountList';
        break;
      case 3:
        url += '?from=admin&to=user';
        url += `&userID=${advUserId}`;
        url += '#/helper/helpCenter~tid=29&isAdmin=0';
        break;
      default:
        url = '';
        break;
    }

    url && this.openUrl(url, { newWin: true });
  },
};

// 深复制
export function clone(obj, hash = new WeakMap()) {
  // eslint-disable-next-line no-eq-null
  if (!(typeof obj === 'object' && obj !== null)) {
    return obj;
  }

  if (hash.has(obj)) {
    return hash.get(obj);
  }

  // const target = Object.prototype.toString.call(obj) === '[object Array]' ? [] : {}
  const target = Array.isArray(obj) ? [] : {};
  hash.set(obj, target);

  let result = Object.keys(obj).map((key) => ({
    [key]: clone(obj[key], hash),
  }));

  return Object.assign(target, ...result);
}

// 序列化反序列化复制
export function jClone(obj) {
  return JSON.parse(JSON.stringify(obj));
}

/**
 * 部分属性复制
 * @param {Object} obj 目标对象
 * @param {Array} attrs 所需属性
 * @param {Boolean} deep 深拷贝？ 默认：false
 * */
export function pick(obj = {}, attrs = [], deep = false) {
  return attrs.reduce((i, v) => {
    v in obj && (i[v] = deep ? JSON.parse(JSON.stringify(obj[v])) : obj[v]);
    return i;
  }, {});
}
